import React, { useContext, useEffect, useState } from 'react';
import { TemplateContext } from '../layout';
import formatCurrency from '../func/currency_formatter';
import CheckedIcon from '/fallbacks/check.svg';
import parse from 'html-react-parser';

const WarrantyCheckbox = ({ marginTop, data }) => {
	const [templateContext, setTemplateContext] = useContext(TemplateContext);
	const productPackWarrantyCheckboxTitle = templateContext?.config?.warrantyTexts?.tr_product_pack_warranty_box_title;
	const productPackWarrantyCheckboxText =
		templateContext?.config?.warrantyTexts?.tr_product_pack_warranty_box_body_text;

	const warrantyCheckboxTitle = data?.tr_checkout_v3_warrantyCheckvoxHeading;
	const warrantyCheckboxText = data?.tr_checkout_v3_warrantyCheckboxText;

	const warrantyCheckboxTitleTextRendered = productPackWarrantyCheckboxTitle
		? productPackWarrantyCheckboxTitle
		: warrantyCheckboxTitle;
	const warrantyCheckboxBodyTextRendered = productPackWarrantyCheckboxText
		? productPackWarrantyCheckboxText
		: warrantyCheckboxText;
	const [parsedText, setParsedText] = useState(warrantyCheckboxBodyTextRendered);

	const textColor = data?.checkout_v3_warrantyCheckboxColor;

	useEffect(() => {
		const formatedAmount = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, templateContext?.config?.product?.warranty_price)
			: formatCurrency(Number(templateContext?.config?.product?.warranty_price)).toString();
		const text = warrantyCheckboxBodyTextRendered.replace('###react_warrPrice###', formatedAmount);
		setParsedText(text);
	}, [templateContext?.config?.product?.warranty_price]);

	const toggleWarrantyCheckbox = () => {
		if (templateContext?.displayPopup && !templateContext.popupClicked) {
			setTemplateContext({
				...templateContext,
				config: { ...templateContext.config, warrantyState: true },
				displayPopup: false,
				popupClicked: true,
			});
		} else {
			setTemplateContext({
				...templateContext,
				config: { ...templateContext.config, warrantyState: !templateContext.config.warrantyState },
			});
		}
	};

	return (
		<section
			style={templateContext?.config?.warrantyState ? { zIndex: 1 } : { zIndex: 40 }}
			className={marginTop ? 'warranty warranty--top' : 'warranty'}
		>
			<div className="warranty__checkbox">
				<input
					className="warranty__input"
					checked={templateContext?.config?.warrantyState}
					type="checkbox"
					id="warranty"
					onClick={() => {
						toggleWarrantyCheckbox();
					}}
				/>
				<label className="warranty__label" htmlFor="warranty" style={{ color: textColor }}>
					{warrantyCheckboxTitleTextRendered}
				</label>
				<label htmlFor="warranty" className="warranty__check">
					<span style={{ backgroundImage: `url(${CheckedIcon})` }}></span>
				</label>
			</div>
			<div className="warranty__text" style={{ color: textColor }}>
				{parse(parsedText)}
			</div>
		</section>
	);
};

export default WarrantyCheckbox;
